import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useWorkout } from "../hooks/workoutHook";
import { getRequest } from "../../api/axiosRequests";
import Failed from "../../loading/pages/Failed";
import Loading from "../../loading/pages/Loading";
import WorkoutHeader from "./WorkoutHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";

export default function WorkoutLayout() {
  const navigate = useNavigate();
  const { idPlanDay, idWorkout, idSuperserie, idExercise } = useParams();
  const workoutContext = useWorkout();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("jwt");
    if (!token || token === "" || token === undefined || token === null) {
      navigate("/login");
      return;
    }
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promiseUser = getRequest("userData/", headers);
    const promiseWorkout = getRequest("fullWorkout/" + idWorkout, headers);
    Promise.all([promiseUser, promiseWorkout])
      .then((values) => {
        const workoutData = values[1].data;
        workoutContext.setWorkoutData({
          idPlanDay: idPlanDay,
          idWorkout: idWorkout,
          idSuperserie: idSuperserie,
          idExercise: idExercise,
          workout: workoutData,
        });
        setIsLoaded(true);
        setIsFailed(false);
      })
      .catch((errs) => {
        setIsLoaded(true);
        setIsFailed(true);
      });
  }, []);

  return (
    <>
      {!isLoaded && (
        <>
          <WorkoutHeader title={""} showInfo={false} showCompleted={false} />
          <ContainerResponsive>
            <Loading paddingTop={30} />
          </ContainerResponsive>
        </>
      )}
      {isLoaded && isFailed && (
        <>
          <WorkoutHeader title={""} showInfo={false} showCompleted={false} />
          <ContainerResponsive>
            <Failed
              mainDescription={"Failed to reach the Server."}
              secondaryDescription={
                "Check your internet connection and try again."
              }
              paddingTop={30}
            />
          </ContainerResponsive>
        </>
      )}
      {isLoaded && !isFailed && <Outlet />}
    </>
  );
}
